import { IonButton } from '@ionic/react';
import { FC } from 'react';
import { CareMapState } from '../caremap/CareMapState';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CommunityModelFactory } from '../share-caremap/CommunityModelFactory';
import { useSubscription } from '@meraki-internal/state';

export const RemoveMeButton: FC = () => {
    const careMapState = useInstance(CareMapState);
    const factory = useInstance(CommunityModelFactory);
    useSubscription(() => factory);
    const community = factory.forActiveCaremap();

    return community.canRemoveSelf() && (
        <IonButton
            data-type="remove-me"
            expand="block"
            fill="outline"
            color="danger"
            onClick={careMapState.removeMe}
        >Remove Me</IonButton>
    );
};
